export const ROLE_THYAGA_ADMINISTRATOR = 'ROLE_THYAGA_ADMINISTRATOR';
export const ROLE_MERCHANT_ADMINISTRATOR = 'ROLE_MERCHANT_ADMINISTRATOR';
export const ROLE_SUB_MERCHANT_ADMINISTRATOR =
  'ROLE_SUB_MERCHANT_ADMINISTRATOR';
export const ROLE_THYAGA_ACCOUNTANT = 'ROLE_THYAGA_ACCOUNTANT';
export const ROLE_THYAGA_SCHEDULER = 'ROLE_THYAGA_SCHEDULER';
export const ROLE_MERCHANT_REDEMPTIONS = 'ROLE_MERCHANT_REDEMPTIONS';
export const ROLE_THYAGA_CUSTOMER_CARE = 'ROLE_THYAGA_CUSTOMER_CARE';
export const ROLE_THYAGA_MERCHANT_CONTROLLER =
  'ROLE_THYAGA_MERCHANT_CONTROLLER';
export const ROLE_THYAGA_SALES_AGENT = 'ROLE_THYAGA_SALES_AGENT';
export const ROLE_THYAGA_MARKETING = 'ROLE_THYAGA_MARKETING';
export const ROLE_REWARD_CLIENT_USER = 'ROLE_REWARD_CLIENT_USER';

export const MERCHANT_SCOPED_ROLES = [
  ROLE_MERCHANT_ADMINISTRATOR,
  ROLE_SUB_MERCHANT_ADMINISTRATOR,
];

export const ROLES_ACCESSIBLE_BY = {
  [ROLE_THYAGA_ADMINISTRATOR]: [
    ROLE_THYAGA_ADMINISTRATOR,
    ROLE_MERCHANT_ADMINISTRATOR,
    ROLE_SUB_MERCHANT_ADMINISTRATOR,
    ROLE_THYAGA_ACCOUNTANT,
    ROLE_THYAGA_SCHEDULER,
    ROLE_MERCHANT_REDEMPTIONS,
    ROLE_THYAGA_CUSTOMER_CARE,
    ROLE_THYAGA_MERCHANT_CONTROLLER,
    ROLE_THYAGA_SALES_AGENT,
    ROLE_THYAGA_MARKETING,
    ROLE_REWARD_CLIENT_USER,
  ],
  [ROLE_THYAGA_MERCHANT_CONTROLLER]: [
    ROLE_MERCHANT_ADMINISTRATOR,
    ROLE_SUB_MERCHANT_ADMINISTRATOR,
  ],
};

export const getAccessibleRoles = (currentUserRole) => {
  return ROLES_ACCESSIBLE_BY[currentUserRole] || [];
};

export const getRoleLabel = (role) => (role ? role.replace(/_/g, ' ') : role);
